import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { PastureForm } from 'src/@types/validations/Local'
import { useAuth } from 'src/contexts/auth'
import { PastureController } from 'src/controllers/pasture.controller'
import { Status } from 'src/dto/pasture.dto'

const pastureController = new PastureController()
export function useUpdatePasture() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updatePasture', farmId],
    mutationFn: async (data: PastureForm) => {
      try {
        const pasture = await pastureController.updatePasture(farmId!, data)

        if (data.acao === 'Removido') return

        await pastureController.createPastureHistoric(farmId!, {
          idPasto: pasture.idPasto!,
          descricao: data.descricao,
          area: data.area ? (typeof data.area === 'string' ? parseFloat(data.area) : data.area) : null,
          pasto: data.pasto as Status,
          cerca: data.cerca as Status,
          aguadas: data.aguados as Status,
          saleiros: data.saleiros as Status,
          idFazenda: farmId!,
          data: new Date().toISOString(),
          idFazendaIdPasto: `${farmId!}#${pasture.idPasto}`
        })
      } catch (error) {
        console.error('Error updating pasture and creating historic:', error)
        throw error
      }
    },
    onSuccess: (_, payload) => {
      toastSyncSuccess(`Local ${payload?.idPasto ? 'atualizado' : 'criado'} com sucesso!`)
    },
    onError: (_, payload) => {
      toast.error(`Erro ao ${payload?.idPasto ? 'atualizar' : 'criar'} local`)
    }
  })
}
